import { Card } from "@izicvs/ui";
import { cn } from "@izicvs/utils";
import { forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
};

export const BaseCard = forwardRef<HTMLDivElement, Props>(
  ({ children, className, onClick }, ref) => (
    <Card
      ref={ref}
      className={cn(
        "group/card relative flex aspect-[1/1.4142] cursor-pointer items-center justify-center overflow-hidden bg-secondary/50 p-0 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-xl active:scale-[0.98]",
        className,
      )}
      onClick={onClick}
    >
      {children}
    </Card>
  ),
);
